import {createBrowserHistory} from 'history';

export const browserHistory = createBrowserHistory({window});

export function redirectTo(url: string, state?: unknown): void {
  browserHistory.push(url, {from: browserHistory.location.pathname, state: state});
}
